// extracted by mini-css-extract-plugin
module.exports = {"main":"NoticeGDPR_main__2MkX1","unset":"NoticeGDPR_unset__1hf2S"};